import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import TButton from "../atoms/buttons/TButton";

import { ITextButton } from "../atoms/buttons/types";

// --------------------------------------------------------------------------------------------

export type IOpeningCardList = {
  key: string;
  value: string;
};

export type IOpeningCard = {
  heading?: string;
  list?: IOpeningCardList[];
  button?: ITextButton;
  isHiring?: boolean;
};

export type ICurrentOpeningCardPorps = HTMLAttributes<HTMLDivElement> &
  IOpeningCard & {};

const CurrentOpeningCard: FC<ICurrentOpeningCardPorps> = (props) => {
  const { heading, list, button, isHiring, className, ...other } = props;

  if (!isHiring) return null;

  return (
    <div
      className={clsx(
        "group relative block min-h-[318px] gap-4 border-transparent bg-white p-5 transition-all duration-1000 ease-in-out hover:bg-primary-900 md:min-h-[354px] md:p-6 xl:min-h-[384px] xl:p-7",
        className,
      )}
      {...other}
    >
      {heading && (
        <h5 className="mb-5 line-clamp-2 text-lg font-medium text-primary-900 duration-[800ms] ease-in-out group-hover:text-white group-hover:transition-all lg:mb-7 lg:text-h6 xl:text-h5">
          {heading}
        </h5>
      )}

      <ul className="mb-[72px]">
        {list?.map((item, idx) => (
          <li
            key={idx}
            className="mb-2.5 w-full border-b border-b-primary-100 pb-2.5 last:mb-0 last:border-none last:pb-0"
          >
            <p className="text-base font-normal text-black-900 duration-[800ms] group-hover:text-white group-hover:transition-all group-hover:ease-linear">
              {item.key}
              {" : "}
              <span className="text-gray-500 duration-[800ms] ease-in-out group-hover:text-primary-300 group-hover:transition-all">
                {item.value}
              </span>
            </p>
          </li>
        ))}
      </ul>
      {button && (
        <TButton
          id={button.id}
          variant={button.variant}
          href={button.link}
          radius={button.radius}
          target={button.target}
          className="absolute bottom-5 opacity-0 duration-[1000ms] ease-in-out group-hover:opacity-100 group-hover:transition-all lg:bottom-6 xl:bottom-7"
        >
          {button.text}
        </TButton>
      )}
    </div>
  );
};

export default CurrentOpeningCard;
